import * as THREE from 'three';
import { getPalette } from './palette';

/**
 * Decorative water plane: terrain below WATER_Y reads as lakes.
 * Flat plane, not simulation — real floating physics is a later phase.
 */
export const WATER_Y = 0.45;

export function buildWater(scene: THREE.Scene): THREE.Mesh {
  const pal = getPalette();
  const waterHex = pal.colors.water?.hex ?? '#3399FF';
  const mesh = new THREE.Mesh(
    new THREE.PlaneGeometry(400, 400),
    new THREE.MeshStandardMaterial({
      color: new THREE.Color(waterHex),
      transparent: true,
      opacity: 0.8,
      roughness: 0.1,
      metalness: 0.3,
    }),
  );
  mesh.rotation.x = -Math.PI / 2;
  mesh.position.y = WATER_Y;
  scene.add(mesh);
  return mesh;
}
